export const appName = `header`;
export const disabledSearchPages = [/^\/[A-z_]+\/new_v2/, /^\/products/];
